import { required } from "vuelidate/lib/validators";

export default class GrupoData {
  nome = "";

  imagem = null;

  remover_imagem = false;

  id = null;

  constructor({ nome = "", imagem = null, remover_imagem = false, id = null }) {
    this.nome = nome;
    this.imagem = imagem;
    this.remover_imagem = remover_imagem;
    this.id = id;
  }
}

export const GrupoDataRequired = {
  nome: {
    required,
  },
};
